<template>
  <v-card>
    <v-card-title primary-title>
      <div>
        <div class="headline secondary--text">
          {{$t('screener.affiliation.list.title')}}
        </div>
        <span class="body-1 greyDarken1--text">{{$t('screener.affiliation.list.subtitle')}}</span>
      </div>
      <v-spacer></v-spacer>
      <AffiliationCreate :dialog.sync="dialog"></AffiliationCreate>
      <v-btn color="secondary" dark class="mx-0" @click="dialog = true">
        <v-icon small>$vuetify.icons.rms_create</v-icon>
        {{ $t("rms.button.create") }}
      </v-btn>
    </v-card-title>
      <v-layout row wrap class="pa-3">
        <v-flex xs12 sm4 md4>
          <v-text-field
            append-outer-icon="search"
            v-model="search"
            :placeholder="$t('screener.affiliation.list.search.placeholder')"
            clear-inner-icon="rms_close"
            clearable
            single-line
            hide-details
            @click:clear="clearSearch"
            @click:append-outer="applySearch"
          ></v-text-field>
        </v-flex>
        <v-spacer></v-spacer>
        <!-- <v-flex xs12 sm3 md3>
          <v-select
              v-model="status"
              :items="DEFINES.COUPON_STATUS"
              :label="$t('Affiliation Status')"
              item-text="text"
              item-value="value"
              @input="getCouponsList(1)"
              class="pr-2"
            ></v-select>
        </v-flex> -->
      </v-layout>

    <v-data-table
      :headers="table_headers"
       :loading="loading"
      :items="affiliations"
      :pagination.sync="pagination"
      :total-items="total"
      :rowsPerPageItems="rowsPerPageItems"
      item-key="id"
    >
      <template  v-slot:items="props">
        <tr style="cursor:pointer" @click.stop="viewAffiliationDetail(props.item.id)">
          <td class="body-2">{{props.item.id}}</td>
          <td class="subheading">{{props.item.code}}
            <v-btn
            class="pa-0 ma-0"
            small
            icon
            dark
            @click.stop="copyToClipboard(props.item.code)"
            >
              <v-icon small color="primary">$vuetify.icons.rms_copy</v-icon>
            </v-btn>
          <td>{{props.item.title}}</td>
          <td>{{props.item.reporting_email}}</td>
          <td>{{props.item.revenue_percentage}}%</td>
          <td>{{props.item.hits}}</td>
           <td>{{props.item.conversions}}</td>
          <td>{{props.item.validity}}</td>
          <td>
            <v-chip
              :color="props.item.enabled ? 'success' : 'error'"
              small
              outline
              dark
              >{{ props.item.enabled ? $t('screener.affiliation.status.enabled.title') : $t('screener.affiliation.status.disabled.title') }}</v-chip>
          </td>
          <td>{{fmtTime(props.item.last_reported_at)}}</td>
          <td>{{fmtTime(props.item.created_at)}}</td>
          <!-- No need of deletion -->
          <!-- <td>
            <ConfirmationDialog
              :headline="'screener.affiliation.delete.confirmation.dialog.title'"
              :desc="'screener.affiliation.delete.confirmation.dialog.desc'"
              :action="getDialogAction(props.item.id, 'rms_delete', 'error')"
              :button_type="'icon'"
            ></ConfirmationDialog>
          </td> -->
        </tr>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";
import { mapFields } from "vuex-map-fields";
import moment from "moment";
import AffiliationCreate from "@/pages/affiliation/Create";
import { utcToTz } from "@/helper";
import ConfirmationDialog from "@/components/ConfirmationDialog";

export default {
  name: "AffiliationList",
  async beforeRouteEnter(to, from, next) {
    await next(vm => {
      vm.getAffiliationList();
    });
  },
  components: {
    AffiliationCreate,
    ConfirmationDialog
  },
  data() {
    return {
      dialog: false,
      moment,
      table_headers: [
        {
          text: this.$t('screener.affiliation.list.table.id'),
          sortable: true,
          align: "left",
          value: "id",
          tooltip: ""
        },
        {
          text: this.$t('screener.affiliation.list.table.code'),
          sortable: true,
          align: "left",
          value: "code",
          tooltip: ""
        },
        {
          text: this.$t('screener.affiliation.list.table.title'),
          sortable: true,
          align: "left",
          value: "title",
          tooltip: ""
        },
        {
          text: this.$t('screener.affiliation.list.table.email'),
          sortable: true,
          align: "left",
          value: "reporting_email",
          tooltip: ""
        },
        {
          text: this.$t('screener.affiliation.list.table.revenue_percent'),
          sortable: true,
          align: "left",
          value: "revenue_percentage",
          tooltip: ""
        },
        {
          text: this.$t('screener.affiliation.list.table.hits'),
          sortable: true,
          align: "left",
          value: "hits",
          tooltip: ""
        },
        {
          text: this.$t('screener.affiliation.list.table.conversions'),
          sortable: false,
          align: "left",
          value: "conversions",
          tooltip: ""
        },
        {
          text: this.$t('screener.affiliation.list.table.validity'),
          sortable: true,
          align: "left",
          value: "validity",
          tooltip: ""
        },
        {
          text: this.$t('screener.affiliation.list.table.status'),
          sortable: true,
          align: "left",
          value: "enabled",
          tooltip: ""
        },
        {
          text: this.$t('screener.affiliation.last_reported_at.title'),
          align: "left",
          value: "last_reported_at",
          sortable: true,
          tooltip: ""
        },
        {
          text: this.$t('screener.affiliation.list.table.created_at'),
          align: "left",
          value: "created_at",
          sortable: true,
          tooltip: ""
        }
        //  {
        //   text: "Action",
        //   align: "left",
        //   value: "action",
        //   sortable: false,
        //   tooltip: ""
        // }
      ],
      rowsPerPageItems: [5, 10, 25, 50, 100],
      pagination: {
        sortBy: 'created_at',
        descending: true,
        page: 1,
        rowsPerPage: 10,
      },
      search: '',
      loading: false,
      total: null,
      search: "",
      filters:{}
    };
  },
  watch: {
    pagination: {
      handler:function(newVal,oldVal){
          this.getAffiliationList();
      },
      deep: true
    }
  },
  computed: {
    ...mapFields("affiliation", {
      affiliations: "list"
    }),
    ...mapGetters("company", {
      timezone: "getSelectedCompanyTimezone"
    })
  },
  methods: {
    applySearch() {
      if (this.search.length) this.getAffiliationList();
    },
    clearSearch() {
      this.search = "";
      this.getAffiliationList();
    },
    // convert utc to comapny timezone
    fmtTime(input) {
      return utcToTz(input, this.timezone, "Do MMM YYYY, h:mm a");
    },
    getDialogAction(update_status, btn_icon, btn_color) {
      return {
        button_icon: btn_icon,
        button_color: btn_color,
        method: this.onDelete,
        payload: update_status
      };
    },
    async onDelete(affiliation_id) {
      try {
          await this.$store.dispatch("affiliation/delete", {
            id: affiliation_id
          });
          this.getAffiliationList();
      } catch (error) {
          this.$store.dispatch("app/showMessage", {
            message: error.message,
            color: "error"
          });
      }
    },
    copyToClipboard(item) {
      try {
        this.$copyText(item);
        this.$store.dispatch("app/showMessage", {
          message: this.$t("screener.affiliation.code.copied.successfully"),
          color: "success"
        });
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
    },
    getPaginationOffset: (recordPerPage, page) => recordPerPage * (page - 1),
    async getAffiliationList() {
      try {
        this.loading = true;
        // Pagination
        const {sortBy, descending, page, rowsPerPage} = this.pagination;
        var offset = this.getPaginationOffset(rowsPerPage, page);
        // Payload
        let payload = {
            offset: offset,
            limit: rowsPerPage,
            sort: sortBy,
            sorting_order: descending,
            search: this.search,
            filters: this.filters,
        };
        var response = await this.$store.dispatch("affiliation/list",payload);
        this.total = response.affiliations.total;
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error"
        });
      }
      finally{
        this.loading = false;
      }
    },
    viewAffiliationDetail(affiliation_id) {
      this.$router.push({
        name: "affiliation.update",
        params: {
          affiliation_id: affiliation_id
        }
      });
    }
  }
};
</script>


